"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyPhoneNumber = exports.isPhoneNumberEmpty = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var formik_1 = require("formik");
var TextField_1 = __importDefault(require("../TextField"));
var isPhoneNumberEmpty = function (pn) { return pn.value === ''; };
exports.isPhoneNumberEmpty = isPhoneNumberEmpty;
var createEmptyPhoneNumber = function (type, primary) {
    if (primary === void 0) { primary = false; }
    return ({
        value: '',
        primary: primary,
        type: type,
    });
};
exports.createEmptyPhoneNumber = createEmptyPhoneNumber;
function PhoneNumberField(props) {
    var readOnly = props.readOnly, name = props.name;
    var _a = __read((0, formik_1.useField)(name), 2), meta = _a[1];
    var error = meta.error;
    return ((0, jsx_runtime_1.jsx)(TextField_1.default, __assign({}, props, { readOnly: readOnly, name: "".concat(name, ".value"), type: "tel", error: !!error, helperText: (error || {}).value })));
}
exports.default = PhoneNumberField;
//# sourceMappingURL=PhoneNumberField.js.map